<div class="container text-center">
  <br />
  <h1>Caro Participante</h1>
  <h2>Identificamos que você esta utilizando o Internet Explorer.</h2>
  <p>Infelizmente esse navegador não possui mais suporte pela Microsoft. Por esse motivo e para garantir sua segurança</p>
  <p>e conforto durante a votação, sugerimos a utilização de outros   navegadores mais modernos e seguros</p>

  <p>como o: Vivalde, Opera, Chrome, Safari, Firefox e Edge.</p>
  <img src="https://miro.medium.com/max/2560/1*FrrUxBQx-kWYtv2PN4nVvw.png" class="img-fluid center-block"
    alt="Responsive image" /> <br />
  <p>Lembre-se que alem do seu computador você também pode votar
    pelo seu celular.</p>

  <h3>Boa eleição!</h3>
</div>
